import type { FieldDef, FieldOptionsMeta } from '@citizen-walk/shared-types';

/**
 * rating-scale 固有の optionsMeta editor (Sprint BG-DataSettings 3、旧 DataSettingsPage L425-497)。
 *
 * 編集対象: min / max / excludeZero / scaleLabels.posLabel / scaleLabels.negLabel。
 */
export function RatingScaleEditor({
  field,
  onChange,
  disabled,
}: {
  field: FieldDef;
  onChange: (partial: Partial<FieldDef>) => void;
  disabled?: boolean;
}) {
  const meta: FieldOptionsMeta = field.optionsMeta ?? {};
  const scaleLabels = meta.scaleLabels ?? { posLabel: '', negLabel: '' };

  function patchMeta(partial: Partial<FieldOptionsMeta>) {
    onChange({ optionsMeta: { ...meta, ...partial } });
  }
  function patchScale(partial: Partial<typeof scaleLabels>) {
    onChange({
      optionsMeta: { ...meta, scaleLabels: { ...scaleLabels, ...partial } },
    });
  }

  return (
    <div className="grid grid-cols-1 gap-2 border border-slate-200 rounded p-3 bg-white">
      <span className="text-xs font-medium text-slate-600">スケール設定</span>
      <div className="grid grid-cols-2 gap-2">
        <label className="block">
          <span className="text-xs text-slate-500 block mb-1">最小値</span>
          <input
            type="number"
            value={meta.min ?? -3}
            onChange={(e) => patchMeta({ min: Number(e.target.value) })}
            disabled={disabled}
            className="w-full px-2 py-1.5 border border-slate-300 rounded text-sm"
          />
        </label>
        <label className="block">
          <span className="text-xs text-slate-500 block mb-1">最大値</span>
          <input
            type="number"
            value={meta.max ?? 3}
            onChange={(e) => patchMeta({ max: Number(e.target.value) })}
            disabled={disabled}
            className="w-full px-2 py-1.5 border border-slate-300 rounded text-sm"
          />
        </label>
      </div>
      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={!!meta.excludeZero}
          onChange={(e) => patchMeta({ excludeZero: e.target.checked })}
          disabled={disabled}
        />
        0 を除外する（例: -3,-2,-1,1,2,3 の 6 段階）
      </label>
      <div className="grid grid-cols-2 gap-2">
        <label className="block">
          <span className="text-xs text-slate-500 block mb-1">負側ラベル</span>
          <input
            value={scaleLabels.negLabel}
            onChange={(e) => patchScale({ negLabel: e.target.value })}
            disabled={disabled}
            placeholder="Unhappy"
            className="w-full px-2 py-1.5 border border-slate-300 rounded text-sm"
          />
        </label>
        <label className="block">
          <span className="text-xs text-slate-500 block mb-1">正側ラベル</span>
          <input
            value={scaleLabels.posLabel}
            onChange={(e) => patchScale({ posLabel: e.target.value })}
            disabled={disabled}
            placeholder="Happy"
            className="w-full px-2 py-1.5 border border-slate-300 rounded text-sm"
          />
        </label>
      </div>
    </div>
  );
}
